
<nav class="navbar fixed-bottom navbar-light bg-light">
  <a class="navbar-brand" href="#"></a>
  © {{copyRightYear-1}}-{{copyRightYear}} Copyright | Whittle Group, Inc.
  <a href="/privacyPolicy" class="me-5">Privacy Policy</a>
</nav>

